import {gql} from "graphql-request";

export const GetAccomsByPolygon = gql`
  query GetAccomsByPolygon($polygon: String!, $types: [String!]) {
    accommodationsByPolygon(polygon: $polygon, types: $types) {
      id
      type
      name
      lonlat
      internationalPhoneNumber
      website
      email

    }
  }
`;

export const GetAmenitiesByPolygon = gql`
  query GetAmenitiesByPolygon($polygon: String!, $types: [String!]!) {
    amenitiesByPolygon(polygon: $polygon, types: $types) {
      id
      type
      name
      lonlat
      website
      email
      phone
      wikidata
    }
  }
`;

export const GetPoisByString = gql`
  query GetPoisByString($string:String!,$trailId:Int!,$types:[String!]!){
    poisByString(string:$string,trailId:$trailId,types:$types){
      id
      name
      klass
      type
      lonlat
      website
      email
      trails {
        id
        name
      }
    }
  }
`;

export const GetPOIsPopularByTrail = gql`
  query GetPOIsPopularByTrail($trailId:Int!,$types:[String!]!){
    poisPopularByTrail(trailId:$trailId,types:$types){
      id
      name
      klass
      type
      lonlat
      website
      email
      trails {
        id
        name
      }
      impressionsCount
    }
  }
`;

export const GetPOIByID = gql`
  query GetPoiById($type:String!,$id:ID!){
    poi(type:$type,id:$id) {
      id
      name
      klass
      type
      lonlat
      website
      email
      placeId
      serpData
      trails {
        id
        name
      }
      impressionsCount
    }
  }
`


export interface UpdateAmenityInput {
  id: string;
  placeId?: string;
  // Add other fields that are allowed in UpdateAmenityInput if needed
}

export const UPDATE_AMENITY_MUTATION = gql`
  mutation UpdateAmenity($input: UpdateAmenityInput!) {
    updateAmenity(input: $input) {
      amenity {
        id
        placeId
      }
    }
  }
`;

export interface UpdateAmenityMutationVariables {
  input: UpdateAmenityInput;
}

export interface UpdateAmenityMutationResponse {
  updateAmenity: {
    amenity: {
      id: string;
      placeId: string;
    };
  };
}

export interface UpdateAccommodationInput {
  id: string;
  placeId?: string;
  // Add other fields that are allowed in UpdateAccommodationInput if needed
}

export const UPDATE_ACCOMMODATION_MUTATION = gql`
  mutation UpdateAccommodation($input: UpdateAccommodationInput!) {
    updateAccommodation(input: $input) {
      accommodation {
        id
        placeId
      }
    }
  }
`;

export interface UpdateAccommodationMutationVariables {
  input: UpdateAccommodationInput;
}

export interface UpdateAccommodationMutationResponse {
  updateAccommodation: {
    accommodation: {
      id: string;
      placeId: string;
    };
  };
}
